import type { InstantAssistantDiscoveryUpdatePayload } from "@/types/assistant";

export type AssistantDiscoveryUiState = {
  showGlow: boolean;
  showTooltip: boolean;
  showOverlay: boolean;
  glowFirstSeenAt?: string | null;
  sessionsSinceHint?: number;
};

export const initialDiscoveryState: AssistantDiscoveryUiState = {
  showGlow: true,
  showTooltip: true,
  showOverlay: true,
  glowFirstSeenAt: null,
  sessionsSinceHint: 0,
};

export function deriveDiscoveryUpdateFromUi(
  state: AssistantDiscoveryUiState,
): InstantAssistantDiscoveryUpdatePayload | null {
  const update: InstantAssistantDiscoveryUpdatePayload = {};

  if (!state.showGlow) {
    update.shortcutAcknowledged = true;
  }

  if (!state.showTooltip) {
    update.launcherTooltipDismissed = true;
  }

  if (!state.showOverlay) {
    update.overlayCompleted = true;
  }

  return Object.keys(update).length ? update : null;
}

export function mergeDiscoveryUpdates(
  ...updates: (InstantAssistantDiscoveryUpdatePayload | null | undefined)[]
): InstantAssistantDiscoveryUpdatePayload | null {
  const merged: InstantAssistantDiscoveryUpdatePayload = {};

  for (const update of updates) {
    if (!update) {
      continue;
    }

    if (update.shortcutAcknowledged) {
      merged.shortcutAcknowledged = true;
    }

    if (update.launcherTooltipDismissed) {
      merged.launcherTooltipDismissed = true;
    }

    if (update.overlayCompleted) {
      merged.overlayCompleted = true;
    }

    if (update.glowExpired) {
      merged.glowExpired = true;
    }
  }

  return Object.keys(merged).length ? merged : null;
}
